const bookmeLandingConfig = {
  branding: {
    name: 'BookMe',
    logoUrl: '',
    logoAlt: 'BookMe',
  },
  hero: {
    title: 'Deja de perder clientes:',
    highlight: 'automatiza tu negocio',
    description: 'Reservas, ventas, pagos y comunicación en un solo sistema diseñado para profesionales como tú.',
    ctaText: '¿Qué necesitas para tu negocio?',
    ctaLink: '#lead-form',
    backgroundImage: '',
  },
  sections: {
    featuresTitle: 'Funcionalidades clave',
    featuresSubtitle: '',
    testimonialsTitle: 'Lo que dicen nuestros clientes',
    galleryTitle: 'Tu sistema se ve así',
    gallerySubtitle: 'Panel moderno, adaptable a cualquier dispositivo.',
    formTitle: 'Personaliza tu sistema ideal',
    formSubtitle: 'Cuéntanos sobre tu negocio y agenda una llamada gratuita. Sin compromiso, sin tarjeta.',
    formFootnote: 'Más de 120 negocios ya usan Book Me.',
    footerText: '© 2025 Book Me. Todos los derechos reservados.',
    footerLinkLabel: 'Powered by puertoricowindows.com',
    footerLinkUrl: 'https://puertoricowindows.com',
  },
  theme: {
    primary: '#f97316',
    primaryDark: '#ea580c',
    accent: '#f97316',
    background: '#ffffff',
    surface: '#f9fafb',
    surfaceAlt: '#f3f4f6',
    text: '#111827',
    muted: '#6b7280',
    border: '#e5e7eb',
    heroFrom: '#fff7ed',
    heroTo: '#ffffff',
    cardBg: '#ffffff',
    whatsapp: '#22c55e',
    whatsappHover: '#16a34a',
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, sans-serif',
    fontUrl: '',
  },
  features: [
    {
      id: 'records',
      title: 'Record Automáticos',
      desc: 'Records digitales que capturan toda la información que necesitas.',
      mediaType: 'video',
      media: '/bookme/video1.mp4',
    },
    {
      id: 'pos',
      title: 'POS Inteligente',
      desc: 'Maneja las citas creadas y los balances por día y por cita.',
      mediaType: 'image',
      media: '/bookme/IMG_0134.jpg',
    },
    {
      id: 'store',
      title: 'Tienda Online',
      desc: 'Vende productos y servicios desde la web.',
      mediaType: 'video',
      media: '/bookme/video2.mp4',
    },
    {
      id: 'sms',
      title: 'SMS y Confirmaciones',
      desc: 'Mantén a tus clientes y tu equipo actualizados con las notificaciones.',
      mediaType: 'image',
      media: '/bookme/tex1.jpeg',
    },
  ],
  testimonials: [
    {
      name: 'Carla, Spa Natural',
      text: 'Desde que usamos Book Me, nuestras reservas aumentaron un 40%. ¡Es súper fácil de usar!',
    },
    {
      name: 'Luis, Barbería Pro',
      text: 'Automatizamos todo: citas, pagos y recordatorios. Ya no tengo que usar WhatsApp manual.',
    },
    {
      name: 'María, Estética Glow',
      text: 'Lo mejor fue la atención personalizada. El sistema se adaptó a lo que yo necesitaba.',
    },
  ],
  gallery: [
    '/bookme/IMG_0134.jpg',
    '/bookme/IMG_0135.jpg',
    '/bookme/IMG_0136.jpg',
    '/bookme/IMG_0137.jpg',
    '/bookme/IMG_0138.jpg',
  ],
  whatsapp: {
    number: '17872369189',
    message: 'Hola, tengo preguntas sobre el sistema Book Me',
    labelMobile: 'Hablar con representante',
    labelDesktop: '¿Tienes preguntas? Habla con un representante ahora',
  },
};

export default bookmeLandingConfig;
